export default "query countries{\n    countries{\n        id\n        name\n        isoCode\n    }\n}";